<div class="section" *ngIf="details && details.length">
	<div class="section-header">{{header}}</div>
	<div class="section-details" *ngFor="let prop of details">
		<label class="col-4 bold-text label" i18n>{{prop['label']}}</label>
		<label *ngIf="!prop['view']" class="col-8">{{prop['value']}}</label>
		<a *ngIf="prop['view']" class="col-8" (click)="viewDetailsFor(prop['view'], prop['value'])">{{prop['value']}}</a>
	</div>
</div>
